module.exports = __webpack_public_path__ + "static/media/Yemen.975d14e4.png";